var render, staticRenderFns
import script from "./UITableColumn.vue?vue&type=script&lang=js&"
export * from "./UITableColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37efa36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d37efa36')) {
      api.createRecord('d37efa36', component.options)
    } else {
      api.reload('d37efa36', component.options)
    }
    
  }
}
component.options.__file = "src/components/ui/UITableColumn.vue"
export default component.exports